"use strict";

var _interopRequireDefault = require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createWithBSPrefix;
var _objectWithoutProperties2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("./classNames"));
var _excluded = ["className", "as"];
var _jsxFileName = "/home/cej/Documents/VS_Code/MWeeB/nq-component/src/createWithBSPrefix.js";
var defaultProps = {
  as: "div"
};
function createWithBSPrefix(prefix) {
  var _this = this;
  var BSComponent = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    var className = props.className,
      Tag = props.as,
      rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
    return /*#__PURE__*/_react["default"].createElement(Tag, Object.assign({
      className: (0, _classNames["default"])(prefix, className),
      ref: ref
    }, rest, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 11,
        columnNumber: 13
      }
    }));
  });
  BSComponent.defaultProps = defaultProps;
  return BSComponent;
}